import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, Button, Stack } from '@mui/material';
import axios from 'axios';

const API_URL = 'https://yourapi.com/api/userguide';

export default function UserGuideForm({ open, onClose, editData, onSave }) {
  const [form, setForm] = useState({ title: '', description: '', version: '', module_id: '' });

  useEffect(() => {
    if (editData) setForm(editData);
    else setForm({ title: '', description: '', version: '', module_id: '' });
  }, [editData]);

  const handleSubmit = async () => {
    if (editData)
      await axios.put(`${API_URL}/${editData.user_guide_id}`, form);
    else
      await axios.post(API_URL, form);

    onSave();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{editData ? 'Edit User Guide' : 'Add User Guide'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField label="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          <TextField label="Version" value={form.version} onChange={(e) => setForm({ ...form, version: e.target.value })} />
          <TextField label="Module ID" value={form.module_id} onChange={(e) => setForm({ ...form, module_id: e.target.value })} />
          <TextField multiline rows={3} label="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
          <Button variant="contained" onClick={handleSubmit}>Save</Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
